import { Component, Input, OnInit } from '@angular/core';
import { IAppSettings } from '../models/common-model-interface';
@Component({
  selector: 'gn-mobile-action',
  templateUrl: './mobile-action.component.html',
  styleUrls: ['./mobile-action.component.scss']
})
export class MobileActionComponent implements OnInit {

  @Input() logoutFn: Function;
  @Input() appSettings: IAppSettings;
  @Input() loginUrl: string;

  constructor() { }

  ngOnInit(): void {
  }

}
